export default __webpack_public_path__ + "static/media/background.41d740a1.jpg";